import { render } from "./ChildAuth.vue?vue&type=template&id=7dd65f06"
import script from "./ChildAuth.vue?vue&type=script&lang=js"
export * from "./ChildAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__